import * as React from "react";
import { createRoot } from "react-dom/client";
import { jsx } from "react/jsx-runtime";
import { App } from "./app/App.jsx";

createRoot(document.getElementById(`root`)).render(
  (0, jsx)(React.StrictMode, { children: (0, jsx)(App, {}) }),
);
